import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader from './AppHeader';
import Map from './Map';

class SmsVerification extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            Notifications: false, 
            Del_City: localStorage.getItem('delcity'),
            Del_Area: localStorage.getItem('delarea'),
            Verify: localStorage.getItem('Verify'),
            Customer: localStorage.getItem('userData'),
            SMS_VERIFIED: false
        };

    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmSmsVerify')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmSmsVerify')[0].classList.add('was-validated');

        if(err==0)
        {
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://www.peepkitchen.in/peep/pwa/api/smsverify_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {

                //console.log(result);
                if(result.customer!='') 
                {
                    customer = result.customer;
                    localStorage.setItem('userData',customer);
                    
                    sms_verified = true;
                }

                that.setState({ SMS_VERIFIED:sms_verified });
          });
        }
    }

    render() { 
        
        let AppHeaderClass = 'appHeader bg-primary text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderTitle = 'Select Delivery Location';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';

        return (
            <div>
                {/*<Loader />*/}
                <AppHeader AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} />
                <div id="appCapsule" className="pt-0">
                    <div className="login-form mt-1">
                        <div className="section" style={{height: '300px'}}>
                            <div id="map"><Map
                                google={this.props.google}
                                center={{lat: 18.5204, lng: 73.8567}}
                                height='300px'
                                zoom={15}
                                />
                            </div>
                        </div>
                        <div className="section mt-1 mb-5">
                            <form id="frmMap" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                            <input type="hidden" value="ADD_ADDRESS" className="form-control" name="mode" id="mode" required />
                            <input type="hidden" value={localStorage.getItem('userData')} className="form-control" name="customer" id="customer" required />
                            <p>Please enter your delivery location</p>
                                <div className="form-group boxed">
                                    <div className="input-wrapper">
                                        <input type="text" className="form-control verify-input" name="txtotp" id="txtotp" placeholder="Enter OTP" required />
                                        <div className="invalid-feedback">Please enter otp.</div> 
                                    </div>
                                </div>
                                <div className="form-button-group">
                                    <button type="submit" className="btn btn-primary btn-block btn-lg">Verify</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
      
export default SmsVerification;


// WEBPACK FOOTER //
// ./src/components/LocateInMap.js